import { Pill } from '@/components/ui/pill'

export type TripStatus = 'draft' | 'scheduled' | 'complete'

const variants: Record<TripStatus, 'draft' | 'info' | 'success'> = {
  draft: 'draft',
  scheduled: 'info',
  complete: 'success',
}

const labels: Record<TripStatus, string> = {
  draft: 'Draft',
  scheduled: 'Scheduled',
  complete: 'Complete',
}

export function TripStatusBadge({ status }: { status: TripStatus }) {
  return <Pill variant={variants[status]}>{labels[status]}</Pill>
}
